import React from "react";
import PropTypes from "prop-types";

import { css } from "@oddcommon/utils";
import styles from "./ImageGridBlock.module.scss";

export default function ImageGridBlock(props) {
  const { images, layout, attribution } = props;
  return (
    <div className={css(styles.base, styles[`layout-${layout}`])}>
      {images.map(({ id, src, alt, type }) => (
        <div className={styles.gridItem} key={id}>
          {type.indexOf("mp4") > -1 && <video src={src} muted autoPlay loop playsInline />}
          {type.indexOf("mp4") == -1 && <img src={src + "?fm=webp&w=1920&q=80"} alt={alt} />}
        </div>
      ))}
      {attribution?.trim?.() && <div className={styles.attribution}>{attribution}</div>}
    </div>
  );
}

ImageGridBlock.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    }),
  ),
  attribution: PropTypes.node,
  layout: PropTypes.oneOf(["halves", "thirds", "quarters", "zigzag"]),
};
